import { useNavigate } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
  onClick?: () => void;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  hidden?: boolean;
}

export const Breadcrumb = ({ items, hidden }: BreadcrumbProps) => {
  const navigate = useNavigate();

  if (hidden || !items || items.length === 0) {
    return null;
  }

  const handleClick = (item: BreadcrumbItem) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <nav className="breadcrumb-container" aria-label="breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = !isLast && (!!item.path || !!item.onClick);

        return (
          <span key={index} className="breadcrumb-item-wrapper">
            {isClickable ? (
              <button
                onClick={() => handleClick(item)}
                className="breadcrumb-item breadcrumb-item--link"
                type="button"
              >
                {item.label}
              </button>
            ) : (
              <span className={`breadcrumb-item ${isLast ? 'breadcrumb-item--current' : ''}`}>
                {item.label}
              </span>
            )}
            {!isLast && <span className="breadcrumb-separator">/</span>}
          </span>
        );
      })}
    </nav>
  );
};
